const NodeStyle = {
    width: 100,
    height: 50,
    shape: 'rectangle',
    opacity: 1,
    backgroundColor: '#ffcc00',
    borderColor: '#000',
    borderWidth: 1,
};

const EdgeStyle = {
    thickness: 1,
    backgroundColor: null,
    shape: 'solid',
};

export { NodeStyle, EdgeStyle };
